module.exports = __webpack_public_path__ + "img/tx.rate.daily.e5b50530.png";